// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__CfFZf","box":"WorkspacesBox_box__1WUD-","node":"WorkspacesBox_node__VnVyy"};